__turbopack_context__.v({
  "container": "TrustpilotSection-module__5F7Wma__container",
  "containerHomePage2026": "TrustpilotSection-module__5F7Wma__containerHomePage2026",
  "headingText": "TrustpilotSection-module__5F7Wma__headingText",
  "lastLine": "TrustpilotSection-module__5F7Wma__lastLine",
  "title": "TrustpilotSection-module__5F7Wma__title",
  "titleLine": "TrustpilotSection-module__5F7Wma__titleLine",
  "trustpilotSection": "TrustpilotSection-module__5F7Wma__trustpilotSection",
});
